<template>
    <div>
        <b-modal
                id="upload-verification-documents-popup"
                ref="modal"
                title="Document Upload"
                size="lg"
                hide-footer
                modal-class="hide-footer"
                no-close-on-backdrop
                :hide-header-close="loading"
                no-close-on-esc
                @hidden="onHidden"
        >
            <b-form
                    @submit.stop.prevent="onSubmit()"
                    @reset.stop.prevent="onHidden"
            >
                <!--if country is PAKISTAN-->
                <div class="row custom-model-form">
                    <div v-if="country == 'Pakistan'" class="col-lg-12 mt-2 row">
                        <div v-if="customerDetails.documentInfo.identity.fileName==null" class="col-lg-6">
                            <base-file-input style="margin-bottom: 1px !important;"
                                             inputLabel="ID Document Front Scan Copy *"
                                             v-model="documentUpload.identity"
                                             file-type="identity"
                                             accept="image/*"
                                             v-validate="{
            required: true,
        }"
                                             :required="true"
                                             placeholder="Select scan copy (JPG, PNG or TIFF file)"
                                             name="ID Document Front"
                            ></base-file-input>
                        </div>

                        <div v-if="customerDetails.documentInfo.identityBack.fileName==null" class="col-lg-6">
                            <base-file-input style="margin-bottom: 1px !important;"
                                             inputLabel="ID Document Back Scan Copy *"
                                             v-model="documentUpload.identityBack"
                                             file-type="identity"
                                             accept="image/*"
                                             v-validate="{
            required: true,
        }"
                                             :required="true"
                                             placeholder="Select scan copy (JPG, PNG or TIFF file)"
                                             name="ID Document Back"
                            ></base-file-input>
                        </div>

                        <div v-if="!customerDetails.documentInfo.otherDocuments ||(customerDetails.documentInfo.otherDocuments && customerDetails.documentInfo.otherDocuments.length==0)" class="col-lg-6">
                            <base-file-input style="margin-bottom: 1px !important;"
                                             inputLabel="Additional Documents"
                                             v-model="documentUpload.otherDocuments"
                                             file-type="otherDocuments"
                                             accept="image/*"
                                             v-validate="{
            required: false,
        }"
                                             :required="false"
                                             placeholder="Select scan copy (JPG, PNG or TIFF file)"
                                             name="Additional Documents"
                            ></base-file-input>
                        </div>
                    </div>
                    <!--if country is PAKISTAN-->

                    <!--if country is UAE-->
                    <div v-if="country != 'Pakistan'" class="col-lg-12 mt-2 row">
                        <div v-if="customerDetails.documentInfo.identity.fileName==null" class="col-lg-6">
                            <base-file-input style="margin-bottom: 1px !important;"
                                             inputLabel="Passport Document Scan Copy"
                                             v-model="documentUpload.identity"
                                             file-type="identity"
                                             accept="image/*"
                                             v-validate="{
            required: false,
        }"
                                             :required="false"
                                             placeholder="Select scan copy (JPG, PNG or TIFF file)"
                                             name="Passport"
                            ></base-file-input>
                        </div>
                        <div v-if="customerDetails.documentInfo.fieldEmiratesID.fileName==null" class="col-lg-6 mt-2">
                            <base-file-input style="margin-bottom: 1px !important;"
                                             inputLabel="ID Document Scan Copy (FRONT)"
                                             v-model="documentUpload.emirates"
                                             file-type="utility"
                                             accept="image/*"
                                             v-validate="{
            required: false,
        }"
                                             :required="false"
                                             placeholder="Select scan copy (JPG, PNG or TIFF file)"
                                             name="Emirates Front"
                            ></base-file-input>
                        </div>
                        <div v-if="customerDetails.documentInfo.fieldEmiratesIDBack.fileName==null" class="col-lg-6 mt-2">
                            <base-file-input style="margin-bottom: 1px !important;"
                                             inputLabel="ID Document Scan Copy (BACK)"
                                             v-model="documentUpload.emiratesBack"
                                             file-type="utility"
                                             accept="image/*"
                                             v-validate="{
            required: false,
        }"
                                             :required="false"
                                             placeholder="Select scan copy (JPG, PNG or TIFF file)"
                                             name="Emirates Back"
                            ></base-file-input>
                        </div>
                        <div v-if="customerDetails.documentInfo.visaPage.fileName==null" class="col-lg-6 mt-2">
                            <base-file-input style="margin-bottom: 1px !important;"
                                             inputLabel="Visa Page Scan Copy"
                                             v-model="documentUpload.visaProof"
                                             file-type="utility"
                                             accept="image/*"
                                             v-validate="{
            required: false,
        }"
                                             :required="false"
                                             placeholder="Select scan copy (JPG, PNG or TIFF file)"
                                             name="Visa Proof"
                            ></base-file-input>
                        </div>
                        <div v-if="customerDetails.documentInfo.fieldAddressProof.fileName==null" class="col-lg-6 mt-2">
                            <base-file-input style="margin-bottom: 1px !important;"
                                             inputLabel="Address Proof Scan Copy"
                                             v-model="documentUpload.addressProof"
                                             file-type="utility"
                                             accept="image/*"
                                             v-validate="{
            required: false,
        }"
                                             :required="false"
                                             placeholder="Select scan copy (JPG, PNG or TIFF file)"
                                             name="Address Proof"
                            ></base-file-input>
                        </div>
                        <div v-if="!customerDetails.documentInfo.otherDocuments ||(customerDetails.documentInfo.otherDocuments && customerDetails.documentInfo.otherDocuments.length==0)" class="col-lg-6 mt-2">
                            <base-file-input style="margin-bottom: 1px !important;"
                                             inputLabel="Additional Documents"
                                             v-model="documentUpload.otherDocuments"
                                             file-type="otherDocuments"
                                             accept="image/*"
                                             v-validate="{
            required: false,
        }"
                                             :required="false"
                                             placeholder="Select scan copy (JPG, PNG or TIFF file)"
                                             name="Additional Documents"
                            ></base-file-input>
                        </div>
                    </div>
                    <!--if country is UAE-->


                </div>
                <div class="col-md-12 mt-2 action-buttons">
                    <base-button
                            btn-label="Update"
                            btn-type="submit"
                            btn-variant="primary"
                            :class="loading ? 'disabled' : ''"
                            :disabled="loading"
                    ></base-button>
                    <base-button
                            btn-label="Cancel"
                            btn-type="reset"
                            :disabled="loading"
                            btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>


    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    const customerDocumentsUpdateApi = new resource(
        'customers/update-customer-documents'
    )
    import resource from '@/api/resource'
    import BaseFileInput from "../BaseFileInput";

    export default {
        components: {BaseFileInput},
        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        props: {
            customerDetails: {
                type: Object,
                default: null,
            },
        }, // End of Component > props
        data() {
            return {
                profileType:'',
                country:process.env.VUE_APP_COUNTRY,
                documentUpload:{
                    identity:null,
                    identityBack:null,
                    emirates:null,
                    emiratesBack:null,
                    visaProof:null,
                    addressProof:null,
                    otherDocuments:null
                },
            }
        },
        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters(['loading', 'selectedItem', 'hidePopup']),
        }, // End of Component > methods
        /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */
        watch: {

            /**
             * Handle when the popup hide
             *
             * @return {void}
             */
            hidePopup(value) {
                if (value) {
                    this.onHidden()
                }
            },
        }, // End of Component > computed
        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {

            /**
             * Handle when the modal is closed
             *
             * @return {void}
             */
            onHidden() {
                // clear the selected item
                this.$store.commit('clearItem')
                this.$store.commit('onSubmit', null)
                this.$validator.reset()
                this.$refs.modal.hide()
            }, // End of onHidden() method
            /**
             * Handle when the modal is canceled
             *
             * @return {void}
             */
            async onSubmit() {
                const result = await this.$validator.validateAll()
                if (result) {
                    console.log('this.documentUpload', this.documentUpload)
                    console.log('this.customerDetails', this.customerDetails)
                    try {
                        this.$store.commit('setLoading', true)
                        var { data } =
                            await customerDocumentsUpdateApi.update(
                                this.customerDetails._id,
                                this.documentUpload
                            )
                        if (data) {
                            this.$toasted.show(data.message, {
                                duration: 2000,
                                type: ['success'],
                            })
                            setTimeout(function () {
                                window.location.reload()
                            },1000)
                            this.onHidden()
                            this.$emit('documentsUpdated', true)
                        }
                        this.$store.commit('setLoading', false)
                    } catch (error) {
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setError', error)
                    }
                    // try {
                    //     await this.$store.dispatch('onSubmit', this.formData)
                    // } catch (error) {
                    //     console.log(error, 'There is an error on submit')
                    // }
                } else {
                    this.$store.commit('setError', this.errors.all()[0])
                }
            }, // End of onSubmit() method

        }, // End of Component > watch
    }
</script>
